<template>
  <v-layout>
    <v-row>
      <v-col cols="12" md="3" xl="2">
        <v-card>
          <v-card-title>
            Filtry
          </v-card-title>
          <v-card-text>

          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="9" xl="10">
        <v-card>
          <v-card-title>
            Okresy rozliczeniowe subskrypcji
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-btn
                  class="mx-2"
                  @click="refresh"
              >
                Odśwież
              </v-btn>
            </div>
            <data-table
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="total"
                :loading="loading"
            >
              <template v-slot:item.subscriptionId="{ item }">
                <router-link
                    v-if="item.subscriptionId"
                    :to="{name: 'subscription-details', params: {id: item.subscriptionId}}"
                >
                  #{{ item.subscriptionId }}
                </router-link>
              </template>
              <template v-slot:item.transactionId="{ item }">
                <router-link
                    v-if="item.transactionId"
                    :to="{name: 'transaction-details', params: {id: item.transactionId}}"
                >
                  #{{ item.transactionId }}
                </router-link>
              </template>
              <template v-slot:item.amount="{ item }">
                <span v-if="0 === item.amount" class="green--text">
                  darmowy
                </span>
                <span v-if="0 !== item.amount">
                  {{ formatAmount(item.amount) }} {{ item.currency || 'PLN' }}
                </span>
              </template>
              <template v-slot:item.status="{ item }">
                <span :class="getTransactionStatusColor(item.status)">
                  {{ getTransactionStatusText(item.status) }}
                </span>
              </template>
              <template v-slot:item.periodStart="{ item }">
                {{ localDateTime(item.periodStart, '') }}
              </template>
              <template v-slot:item.periodEnd="{ item }">
                {{ localDateTime(item.periodEnd, '') }}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ localDateTime(item.createdAt, '') }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ localDateTime(item.updatedAt, '') }}
              </template>
            </data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import api from '@/services/api';
import DataTable from "@/components/data-table/DataTable";
import filters from "@/mixins/filters";
import formatters from "@/mixins/formatters";
import {getDatatableParams, setDatatableOptions} from '@/utils/helpers';
import {
  getStatusColor as getTransactionStatusColor,
  getStatusName as getTransactionStatusName,
  getStatusText as getTransactionStatusText,
  isNew as isTransactionNew,
  isFinished as isTransactionFinished,
} from "@/enums/TransactionStatus";

export default {
  props: {
    subscriptionId: {
      type: [String],
      required: false,
      default: '',
    },
  },
  mixins: [
    filters,
    formatters,
  ],
  components: {
    DataTable,
  },
  data() {
    return {
      total: 0,
      items: [],
      loading: false,
      options: {},
      headers: [
        {text: 'Subskrypcja', value: 'subscriptionId', sortable: false},
        {text: 'Płatność', value: 'transactionId', sortable: false},
        {text: 'Kwota', value: 'amount', sortable: false},
        {text: 'Status', value: 'status', sortable: false},
        {text: 'Początek okresu', value: 'periodStart', sortable: false},
        {text: 'Koniec okresu', value: 'periodEnd', sortable: false},
        {text: 'Utworzono', value: 'createdAt', sortable: false},
        {text: 'Ost. aktualizacja', value: 'updatedAt', sortable: false},
        {text: 'Akcje', value: 'actions', sortable: false},
      ],
      filters: {},
      editedIndex: -1,
    }
  },
  created() {
    getDatatableParams.call(this);
    this.load();
  },
  mounted() {
    const self = this;

    this.$root.$on('loadSubscriptionPeriods', (options) => {
      self.load(options);
    });
  },
  watch: {
    options: {
      handler() {
        this.load();
        setDatatableOptions.call(this);
      },
      deep: true,
    },
  },
  methods: {
    appendFilters(params, filters) {
      if (!(filters instanceof Object)) {
        return;
      }

      let subscriptionId = filters.subscriptionId;

      if (this.subscriptionId) {
        subscriptionId = this.subscriptionId;
      }

      this.appendStringFilterIfNonEmpty(params, 'subscriptionId', subscriptionId, 2);
      this.appendStringFilterIfNonEmpty(params, 'transactionId', filters.transactionId, 2);
      this.appendIntFilterIfNonEmpty(params, 'amount', filters.amount);
      this.appendArrayFilterIfNonEmpty(params, 'statuses', filters.statuses);
    },
    load(options = {}) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      options = options || {};

      let filters = {};
      this.appendFilters(filters, options.filters || this.filters);
      this.filters = filters; // Remember them.

      const {page, itemsPerPage} = this.options;
      const params = {
        ...filters,
        offset: page > 1 ? itemsPerPage * (page - 1) : 0
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      api.get('/api/subscription/period', {params})
          .then((response) => {
            this.items = response.data.items;
            this.total = response.data.total;

            if (options.onSuccess) {
              options.onSuccess();
            }
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się pobrać listy okresów.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    refresh() {
      const self = this;
      this.$root.$emit('loadSubscriptionPeriods', {
        onSuccess: () => {
          self.$root.$emit('notify', {
            html: 'Lista okresów odświeżona.',
          });
        }
      });
    },
    stopRowClickPropagation(event) {
      // The following line is required to avoid triggering onRowClicked() method.
      event.cancelBubble = true;
      event.stopPropagation();
    },
    getTransactionStatusColor(status) {
      return getTransactionStatusColor(status);
    },
    getTransactionStatusName(status) {
      return getTransactionStatusName(status);
    },
    getTransactionStatusText(status) {
      if (isTransactionNew(status)) {
        return 'Nowy';
      }

      return getTransactionStatusText(status);
    },
    isTransactionFinished(status) {
      return isTransactionFinished(status);
    },
  },
}
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>